import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchRole, clearRole } from './roleSlice';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '../../utils/storageHelper';
import axiosInstance from '../../utils/axios';

const storedPartner = getLocalStorage('partner');

const initialState = {
  partner: storedPartner ? JSON.parse(storedPartner) : null,
  isAuthenticated: false,
  status: 'idle',
  error: null,
  logoutStatus: 'idle',
};

export const login = createAsyncThunk(
  'auth/login',
  async ({ email, password }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/admin/auth/login`,
        {},
        {
          headers: {
            Authorization: `Basic ${btoa(`${email}:${password}`)}`,
          },
        }
      );

      const userData = response.data.admin;
      if (userData.parent_admin_id) {
        userData.admin_id = userData.parent_admin_id;
      }
      
      if (userData.login_role === 'TEAM_MEMBER') {
        userData.member_id = userData.id;
      }

      dispatch(fetchRole());
      setLocalStorage('partner', JSON.stringify(userData));
      return userData;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || "Login failed"
      );
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      await axiosInstance.post('/admin/auth/logout');
      dispatch(clearRole());
      removeLocalStorage('partner');
      return true;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetPartnerAuth: (state) => {
        state.isAuthenticated = false;
        state.partner = null;
        state.status = 'idle';
        state.error = null;
        state.logoutStatus = 'idle';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.partner = action.payload;
        state.isAuthenticated = true; 
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        state.isAuthenticated = false;
        state.partner = null;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        // Accept both PARTNER and TEAM_MEMBER as authenticated
        if (action.payload.login_role === 'PARTNER' || action.payload.login_role === 'TEAM_MEMBER') {
          state.isAuthenticated = true;
          state.status = 'succeeded';
        }
      })
      .addCase(logout.fulfilled, (state) => {
        state.partner = null;
        state.isAuthenticated = false;
        state.logoutStatus = 'succeeded';
      });
  },
});

export const { resetPartnerAuth } = authSlice.actions;
export default authSlice.reducer;